__turbopack_context__.v({
  "fadeIn": "ParticleWallpaper-module-scss-module__t3wtSG__fadeIn",
  "overlay": "ParticleWallpaper-module-scss-module__t3wtSG__overlay",
  "particleContainer": "ParticleWallpaper-module-scss-module__t3wtSG__particleContainer",
});
